/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Volleerwerbsminderungsrente3Inputs */



/**

* @param {_Class_Volleerwerbsminderungsrente3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_volleerwerbsminderungsrente3 = /** @type {((inputs?: _Class_Volleerwerbsminderungsrente3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Volleerwerbsminderungsrente3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Volle Erwerbsminderungsrente")
});
export { _class_volleerwerbsminderungsrente3 as "_class_VolleErwerbsminderungsRente" }